import dayjs from "utils/config/dayjs.config";
import AppConstants from "global/constants/AppConstants";
import { Result } from "global/constants/AppType";
import { useEffect, useState } from "react";
import AppApi from "api/App/AppApi";
import { isPaginatedData } from "utils/typeGuards/typeGuards";
import Format from "utils/format/Format";
import { useNavigate } from "react-router-dom";

const currentDate = dayjs();
const defaultStartDate = currentDate;
const StartDate = defaultStartDate.format("DD/MM/YYYY");
const date = currentDate.format("DD/MM/YYYY");

const useTransactionManagementModel = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [dash, setDash] = useState<any[]>([]);
  const [listHistory, setListHistory] = useState<any[]>([]);
  const [resultObject, setResultObject] = useState<Result | null>(null);
  const [labels, setLabels] = useState<any>([]);
  const [datasets, setDatasets] = useState<any>([]);

  const [filterParams, setFilterParams] = useState<any>({
    from_date: StartDate,
    to_date: date,
  });

  const getListHistory = async (Params?: any) => {
    let finalParams = Params;
    try {
      setLoading(true);
      // const response = await AppApi.getDashBoard(finalParams);
      //   if (response?.data && isPaginatedData(response.data)) {
      //   setListHistory(response?.data?.items);
      // }
    } catch (error) {
      console.log(error);
      setResultObject({
        type: "error",
        message: AppConstants.ERROR_OCCUR,
      });
    } finally {
      setLoading(false);
    }
  };

  const getDash = async (Params?: any) => {
    let finalParams = Params;
    try {
      setLoading(true);
      // const response = await AppApi.getDashBoard(finalParams);
      // if (response?.data instanceof RawData) {
      //   setListHistory(response?.data?.raw);
      // }
    } catch (error) {
      console.log(error);
      setResultObject({
        type: "error",
        message: AppConstants.ERROR_OCCUR,
      });
    } finally {
      setLoading(false);
    }
  };

  const reload = async () => {
    await getListHistory();
  };

  const onChange = (values: any) => {
    let newFilterParams: any = {
      ...filterParams,
      ...values,
    };

    if (newFilterParams?.date) {
      const formattedDates = newFilterParams.date.map((date: any) => {
        return Format.formatDate(date);
      });

      if (formattedDates.length === 2) {
        let [from_date, to_date] = formattedDates;

        if (new Date(from_date) > new Date(to_date)) {
          [from_date, to_date] = [to_date, from_date];
        }

        newFilterParams.from_date = from_date;
        newFilterParams.to_date = to_date;
      }
      delete newFilterParams.date;
    }

    if (newFilterParams?.status) {
      if (newFilterParams.status?.value !== -1) {
        newFilterParams.status = newFilterParams.status.value;
      } else {
        delete newFilterParams.status;
      }
    }

    setFilterParams(newFilterParams);
  };

  const handleNav = (path: string) => {
    if (!path) return;
    navigate(path);
  };

  useEffect(() => {
    getDash(filterParams);
  }, [filterParams]);

  useEffect(() => {
    if (dash?.length > 0) {
      const tempLabels: any = [];

      dash.forEach((item) => {
        tempLabels.push(dayjs(item.date).format("DD/MM"));
      });

      setLabels(tempLabels);
      setDatasets([
        {
          label: "Đã đăng ký",
          data: [1200, 1500, 1800, 9223, 9500],
          backgroundColor: "rgba(52, 199, 89, 0.2)",
          borderColor: "#34C759",
          borderWidth: 2,
          fill: false,
        },
        {
          label: "Chưa đăng ký",
          data: [800, 1200, 1600, 5000, 6500],
          backgroundColor: "rgba(255, 59, 48, 0.2)",
          borderColor: "#FF3B30",
          borderWidth: 2,
          fill: false,
        },
      ]);
    }
  }, [dash]);

  return {
    loading,
    listHistory,
    defaultStartDate,
    currentDate,
    datasets,
    labels,
    resultObject,
    getListHistory,
    reload,
    onChange,
    handleNav,
  };
};

export default useTransactionManagementModel;
